import {
  type SerializedCompStructure,
  type SerializedPageStructure,
} from '@wix/document-services-types'

import { getVeloIdOf } from './getVeloIdOf'

const getComponentByVeloIdRecursively = <
  Root extends SerializedCompStructure | SerializedPageStructure,
>({
  root,
  veloId,
}: {
  root: Root
  veloId: string
}): SerializedCompStructure | null => {
  const { components } = root
  if (components !== undefined) {
    for (let index = 0; index < components.length; index += 1) {
      const component = components[index]
      const componentVeloId = getVeloIdOf(component)
      const foundComponent =
        componentVeloId === veloId
          ? component
          : getComponentByVeloIdRecursively({
              root: component,
              veloId,
            })

      if (foundComponent !== null) {
        return foundComponent
      }
    }
  }

  return null
}

export const getComponentByVeloId = <
  Root extends SerializedCompStructure | SerializedPageStructure,
>({
  root,
  veloId,
}: {
  root: Root
  veloId: string
}): SerializedCompStructure => {
  const foundComponent = getComponentByVeloIdRecursively({ root, veloId })
  if (foundComponent === null) {
    throw new Error(`No component with Velo ID "${veloId}" found.`)
  }
  return foundComponent
}
